import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '../../../img/arrow.png';
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "name"
};
const _hoisted_4 = {
  class: "Content"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "topOne"
};
const _hoisted_8 = {
  class: "elcarousel"
};
const _hoisted_9 = {
  class: "img-box"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "title"
};
const _hoisted_13 = {
  class: "name"
};
const _hoisted_14 = {
  class: "titleBox"
};
const _hoisted_15 = {
  class: "title"
};
const _hoisted_16 = {
  class: "left"
};
const _hoisted_17 = {
  class: "right"
};
const _hoisted_18 = {
  class: "Content"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "titles"
};
const _hoisted_21 = {
  class: "time"
};
const _hoisted_22 = {
  class: "topTwo"
};
const _hoisted_23 = {
  class: "lefts"
};
const _hoisted_24 = {
  class: "titleBox"
};
const _hoisted_25 = {
  class: "title"
};
const _hoisted_26 = {
  class: "left"
};
const _hoisted_27 = {
  class: "name names"
};
const _hoisted_28 = {
  class: "right"
};
const _hoisted_29 = {
  class: "Content"
};
const _hoisted_30 = ["onClick"];
const _hoisted_31 = {
  class: "titles"
};
const _hoisted_32 = {
  class: "time"
};
const _hoisted_33 = {
  class: "rights"
};
const _hoisted_34 = {
  class: "titleBox"
};
const _hoisted_35 = {
  class: "title"
};
const _hoisted_36 = {
  class: "left"
};
const _hoisted_37 = {
  class: "name names"
};
const _hoisted_38 = {
  class: "right"
};
const _hoisted_39 = {
  class: "Content"
};
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
  class: "titles"
};
const _hoisted_42 = {
  class: "time"
};
const _hoisted_43 = {
  class: "topS"
};
const _hoisted_44 = ["onClick"];
const _hoisted_45 = ["src"];
const _hoisted_46 = {
  class: "namess"
};
import { reactive, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { bannerListConfig, treeSelectConfig, showMembersConfig } from "../../../api/home";
import { BMPGL } from "@/bmpgl.js";
import { ref } from "vue";
export default {
  __name: 'Home',
  setup(__props) {
    const one = ref(true); //当one为true时执行轮播。以此来控制每次轮播图切换的张数为1
    const swiper = ref(null);
    const data = reactive({
      technologyLists: [],
      bannerLists: [],
      type: 3,
      dataList: []
    });
    const route = useRoute();
    const router = useRouter();
    const treeSelect = () => {
      treeSelectConfig().then(res => {
        data.technologyLists = res.data;
      });
    };
    const bannerList = () => {
      bannerListConfig().then(res => {
        data.bannerLists = res.data;
      });
    };
    const typeBtn = id => {
      data.type = id;
    };
    const technologyBtn = (type, userId, ids) => {
      if (type == 0) {
        router.push({
          path: "/medium",
          query: {
            userId: userId
          }
        });
      } else {
        router.push({
          path: "/medium",
          query: {
            ids: userId,
            userId: ids
          }
        });
      }
    };
    const showMembersBtn = () => {
      showMembersConfig().then(res => {
        data.dataList = res.data;
        let newDataList = [];
        let current = 0;
        if (data.dataList && data.dataList.length > 0) {
          for (let i = 0; i <= data.dataList.length - 1; i++) {
            if (i % 7 !== 0 || i === 0) {
              if (!newDataList[current]) {
                newDataList.push([data.dataList[i]]);
              } else {
                newDataList[current].push(data.dataList[i]);
              }
            } else {
              current++;
              newDataList.push([data.dataList[i]]);
            }
          }
        }
        data.dataList = [...newDataList];
      });
    };
    const articleVOBtn = (catalogueFid, catalogueId, id) => {
      router.push({
        path: "/public",
        query: {
          ids: id,
          id: catalogueId,
          userId: catalogueFid
        }
      });
    };
    const btn = url => {
      window.open(url, '_blank');
    };
    onMounted(() => {
      // 代码逻辑0
      treeSelect();
      bannerList();
      showMembersBtn();
    });
    return (_ctx, _cache) => {
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(data.technologyLists[0]?.name), 1), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.technologyLists[0]?.articleVOList, (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [index <= 3 ? (_openBlock(), _createElementBlock("div", {
          class: "Details",
          key: index,
          onClick: $event => articleVOBtn(item.catalogueFid, item.catalogueId, item.id)
        }, [_cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "dian"
        }, null, -1)), _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1)], 8, _hoisted_5)) : _createCommentVNode("", true)], 64);
      }), 256))])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_carousel, {
        height: "446px",
        autoplay: true,
        interval: 4000
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.bannerLists, item => {
          return _openBlock(), _createBlock(_component_el_carousel_item, {
            key: item,
            onClick: $event => articleVOBtn(item.catalogueFid, item.catalogueId, item.id)
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
              class: "bg",
              src: item.fileUrl
            }, null, 8, _hoisted_10), _createElementVNode("img", {
              class: "main",
              src: item.fileUrl
            }, null, 8, _hoisted_11)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(item.name), 1)])]),
            _: 2
          }, 1032, ["onClick"]);
        }), 128))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
        class: _normalizeClass(["name", data.type == 3 ? 'names' : 'name']),
        onClick: _cache[0] || (_cache[0] = $event => typeBtn(3))
      }, _toDisplayString(data.technologyLists[3]?.name), 3), _createElementVNode("div", {
        class: _normalizeClass(["name", data.type == 4 ? 'names' : 'name']),
        onClick: _cache[1] || (_cache[1] = $event => typeBtn(4))
      }, _toDisplayString(data.technologyLists[4]?.name), 3)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
        class: "name",
        onClick: _cache[2] || (_cache[2] = $event => technologyBtn(data.technologyLists[data.type]?.level, data.technologyLists[data.type]?.id, data.technologyLists[data.type]?.articleVOList[0].catalogueFid))
      }, " 更多"), _cache[6] || (_cache[6] = _createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1))])]), _createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.technologyLists[data.type]?.articleVOList, (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [index <= 10 ? (_openBlock(), _createElementBlock("div", {
          class: "Details",
          key: index,
          onClick: $event => articleVOBtn(item.catalogueFid, item.catalogueId, item.id)
        }, [_cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "dian"
        }, null, -1)), _createElementVNode("div", _hoisted_20, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_21, _toDisplayString(item.releaseTimeNew), 1)], 8, _hoisted_19)) : _createCommentVNode("", true)], 64);
      }), 256))])])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString(data.technologyLists[2]?.name), 1)]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", {
        class: "name",
        onClick: _cache[3] || (_cache[3] = $event => technologyBtn(data.technologyLists[2]?.level, data.technologyLists[2]?.id))
      }, "更多 "), _cache[8] || (_cache[8] = _createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1))])]), _createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.technologyLists[2]?.articleVOList, (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [index <= 8 ? (_openBlock(), _createElementBlock("div", {
          class: "Details",
          key: index,
          onClick: $event => articleVOBtn(item.catalogueFid, item.catalogueId, item.id)
        }, [_cache[9] || (_cache[9] = _createElementVNode("div", {
          class: "dian"
        }, null, -1)), _createElementVNode("div", _hoisted_31, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_32, _toDisplayString(item.releaseTimeNew), 1)], 8, _hoisted_30)) : _createCommentVNode("", true)], 64);
      }), 256))])])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, _toDisplayString(data.technologyLists[1]?.name), 1)]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", {
        class: "name",
        onClick: _cache[4] || (_cache[4] = $event => technologyBtn(data.technologyLists[1]?.level, data.technologyLists[1]?.id))
      }, "更多 "), _cache[10] || (_cache[10] = _createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1))])]), _createElementVNode("div", _hoisted_39, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.technologyLists[1]?.articleVOList, (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [index <= 8 ? (_openBlock(), _createElementBlock("div", {
          class: "Details",
          key: index,
          onClick: $event => articleVOBtn(item.catalogueFid, item.catalogueId, item.id)
        }, [_cache[11] || (_cache[11] = _createElementVNode("div", {
          class: "dian"
        }, null, -1)), _createElementVNode("div", _hoisted_41, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_42, _toDisplayString(item.releaseTimeNew), 1)], 8, _hoisted_40)) : _createCommentVNode("", true)], 64);
      }), 256))])])])]), _createElementVNode("div", _hoisted_43, [_cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "title"
      }, [_createElementVNode("div", {
        class: "left"
      }, [_createElementVNode("div", {
        class: "names"
      }, "会员展示")])], -1)), _createVNode(_component_el_carousel, {
        class: "topScarousel",
        interval: 4000
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.dataList, (list, index) => {
          return _openBlock(), _createBlock(_component_el_carousel_item, {
            class: "el-car-item",
            key: index
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (imgList, index2) => {
              return _openBlock(), _createElementBlock("div", {
                class: "topScarouselBox",
                key: index2,
                onClick: $event => btn(imgList.fileUrl)
              }, [_createElementVNode("img", {
                class: "top-img",
                src: imgList.image
              }, null, 8, _hoisted_45), _createElementVNode("div", _hoisted_46, _toDisplayString(imgList.name), 1)], 8, _hoisted_44);
            }), 128))]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })])]);
    };
  }
};